import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {
  formulario;
  TOKEN = localStorage.getItem('token');

  constructor( private http: HttpClient) { }
  
  getProductos(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getProductos/");
  }

  getDedicatorias(): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getDedicatorias/");
  }

  agregarProducto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarProducto/", data);
  }

  editarProducto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarProducto/", data);
  }

  updateProducto(data): Observable<any[]>{
    const headers = new HttpHeaders({'content-Type': 'application/json'});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateProducto/", data);
  }

  getInsumos(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getInsumos/", {headers});
  }

  agregarInsumo(data:any): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarInsumo/", data,);
  }

  editarInsumo(data:any): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarInsumo/", data, {headers});
  }

  updateInsumo(data:any): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateInsumo/", data,);
  }

  getUnidadesMedida(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getUnidadesMedida/", {headers});
  }

  getInsumosFilter(data:any): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getInsumosFilter/", data, {headers});
  }

  getCategoriasInsumos(): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.get<any[]>(environment.BASE_URL+"/api/getCategoriasInsumos/", {headers});
  }

  getInsumosCategorias(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getInsumosCategorias/", data, {headers});
  }

  getInsumosProveedores(data): Observable<any[]>{
    this.TOKEN = localStorage.getItem('token');
    const headers = new HttpHeaders({'content-Type': 'application/json', Authorization: this.TOKEN});
    return this.http.post<any[]>(environment.BASE_URL+"/api/getInsumosProveedores/", data, {headers});
  }


}
